<template>
  <div ref="container" class="roo-message-wrapper"></div>
</template>

<script>
export default {
  name: 'RooMessageWrapper',

  props: {
    markdown: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      reactRoot: null,
    }
  },

  watch: {
    markdown: {
      handler() {
        this.renderReactComponent()
      },
      immediate: false,
    },
    className() {
      this.renderReactComponent()
    },
  },

  mounted() {
    this.renderReactComponent()
  },

  beforeDestroy() {
    this.unmountReactComponent()
  },

  methods: {
    renderReactComponent() {
      if (!window.RooMessageRenderer) {
        console.error('RooMessageRenderer UMD library not loaded')
        return
      }

      try {
        // 获取 React 和 ReactDOM
        const React = window.React
        const ReactDOM = window.ReactDOM

        if (!React || !ReactDOM) {
          console.error('React or ReactDOM not loaded from CDN')
          return
        }

        // UMD 库的默认导出在 window.RooMessageRenderer 上
        // 如果是命名+默认导出，需要访问 .default
        const RooRenderer = window.RooMessageRenderer.default || window.RooMessageRenderer

        const element = React.createElement(RooRenderer, {
          markdown: this.markdown,
          className: this.className,
        })

        // 如果已经有 root，更新它；否则创建新的
        if (this.reactRoot) {
          this.reactRoot.render(element)
        } else {
          // React 18 使用 createRoot API
          this.reactRoot = ReactDOM.createRoot(this.$refs.container)
          this.reactRoot.render(element)
        }
      } catch (error) {
        console.error('Error rendering RooMessageRenderer:', error)
        // 降级显示原始 Markdown
        this.$refs.container.textContent = this.markdown
      }
    },

    unmountReactComponent() {
      if (this.reactRoot) {
        try {
          this.reactRoot.unmount()
          this.reactRoot = null
        } catch (error) {
          console.error('Error unmounting React component:', error)
        }
      }
    },
  },
}
</script>

<style scoped>
.roo-message-wrapper {
  width: 100%;
}
</style>
